// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__toooltipIcon___2XAAE {\n\tfont-size: unset;\n\tdisplay: inline-block;\n\tvertical-align: text-top;\n\tcolor: #cce5ff;;\n\tcursor: pointer;\n}\n\n.css__elementTooltipContainer___30yj_ {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n}\n\n.css__rightMargin___2Xk4D {\n\tmargin-right: 12px;\n}\n\n.css__leftMargin___2e6HE {\n\tmargin-left: 12px;\n}", ""]);
// Exports
exports.locals = {
	"toooltipIcon": "css__toooltipIcon___2XAAE",
	"elementTooltipContainer": "css__elementTooltipContainer___30yj_",
	"rightMargin": "css__rightMargin___2Xk4D",
	"leftMargin": "css__leftMargin___2e6HE"
};
module.exports = exports;
